import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4dc056ff")

_pushScopeId("data-v-4dc056ff")
const _hoisted_1 = { class: "p-d-flex p-flex-row kn-flex" }
const _hoisted_2 = { class: "p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = { class: "document-table-container p-d-flex p-flex-column kn-flex" }
const _hoisted_4 = {
  key: 0,
  id: "document-browser-sidebar-container",
  "data-test": "document-browser-sidebar"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DocumentBrowserBreadcrumb = _resolveComponent("DocumentBrowserBreadcrumb")
  const _component_DocumentBrowserTable = _resolveComponent("DocumentBrowserTable")
  const _component_DocumentBrowserSidebar = _resolveComponent("DocumentBrowserSidebar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.selectedDocument)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              id: "document-detail-backdrop",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDocument = null))
            }))
          : _createCommentVNode("", true),
        (!_ctx.searchMode)
          ? (_openBlock(), _createBlock(_component_DocumentBrowserBreadcrumb, {
              key: 1,
              breadcrumbs: _ctx.breadcrumbs,
              onBreadcrumbClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('breadcrumbClicked', $event)))
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DocumentBrowserTable, {
          propDocuments: _ctx.documents,
          searchMode: _ctx.searchMode,
          onSelected: _ctx.setSelectedDocument,
          onItemSelected: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('itemSelected', $event)))
        }, null, 8, ["propDocuments", "searchMode", "onSelected"])
      ])
    ]),
    (_ctx.selectedDocument)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_DocumentBrowserSidebar, {
            selectedDocument: _ctx.selectedDocument,
            onDocumentCloneClick: _ctx.cloneDocument,
            onDocumentDeleteClick: _ctx.deleteDocument,
            onItemSelected: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('itemSelected', $event))),
            onDocumentChangeStateClicked: _ctx.changeDocumentState,
            onShowDocumentDetails: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('showDocumentDetails', $event)))
          }, null, 8, ["selectedDocument", "onDocumentCloneClick", "onDocumentDeleteClick", "onDocumentChangeStateClicked"])
        ]))
      : _createCommentVNode("", true)
  ]))
})